import { isPlatformServer, Location as NgLocation } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@freelancer/location';
import { Response } from 'express';
import { RESPONSE } from '../../express.tokens';

/*
 * Allows to render a standard 404 page
 *
 * In theory it should be as simple as
 *
    return this.router.navigate(['/internal/404'], {
      skipLocationChange: true,
    });
 *
 * In practice the above code doesn't work due to
 * https://github.com/angular/angular/issues/17004
 *
 * TODO: cleanup that up when the above Angular issue is fixed
 */
@Injectable({
  providedIn: 'root',
})
export class NotFound {
  private previousUrl: string;

  constructor(
    private location: Location,
    private router: Router,
    private ngLocation: NgLocation,
    @Inject(PLATFORM_ID) private platformId: object,
    @Optional() @Inject(RESPONSE) private response: Response,
  ) {}

  /*
   * Call that to render a 404 page when you need it
   */
  render(): Promise<boolean> {
    this.previousUrl = this.location.url;
    return this.router.navigate(['/internal/404'], {
      // this doesn't really do what it should, hence the this.previousUrl +
      // ngLocation.replaceState hack
      skipLocationChange: true,
    });
  }

  /*
   * PRIVATE: only to be used by the 404 pages implementations
   */
  _onRender(): void {
    // set the status code if on the server
    if (isPlatformServer(this.platformId)) {
      this.response
        .status(404)
        .set(
          'Cache-Control',
          'public, s-maxage=600, stale-while-revalidate=600',
        );
    } else if (this.previousUrl) {
      this.ngLocation.replaceState(this.previousUrl);
    }
  }
}
